import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle } from "react-native-svg";

export const IconFormCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconFormCircle"><Circle cx="12" cy="12" r="10" fill="currentColor"/></CentralIconBase>;
});

export default IconFormCircle;
